import { Checkbox } from '@fluentui/react-components';
import { FilterDismissRegular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import { BasicButton } from '@components/common/BasicButton';
import { useSpaceAmenityFilterStyles } from './SpaceAmenityFilter.styles';

export interface SpaceAmenityFilterProps {
  amenityCodes: string[];
  selectedAmenities: Set<string>;
  onToggle: (code: string) => void;
  onReset?: () => void;
}

export const SpaceAmenityFilter: React.FC<SpaceAmenityFilterProps> = ({
  amenityCodes,
  selectedAmenities,
  onToggle,
  onReset,
}) => {
  const styles = useSpaceAmenityFilterStyles();
  const { t } = useTranslation('bookingForm');

  return (
    <div className={styles.root} data-testid="amenity-filter-panel">
      <div className={styles.headerRow}>
        <div className={styles.heading}>{t('bookingForm.spaceFilter.spaceFacilities')}</div>
        {selectedAmenities.size > 0 && onReset && (
          <BasicButton
            className={styles.clearAllButton}
            variant="transparent"
            size="small"
            icon={<FilterDismissRegular />}
            onClick={onReset}
            data-testid="amenity-filter-reset"
          >
            {t('bookingForm.spaceFilter.clearAll')}
          </BasicButton>
        )}
      </div>
      <div className={styles.checkboxGrid}>
        {amenityCodes.map((code) => (
          <Checkbox
            key={code}
            checked={selectedAmenities.has(code)}
            onChange={() => onToggle(code)}
            label={t(`bookingForm.spaceFilter.amenity.${code}`, code)}
            data-testid={`amenity-checkbox-${code}`}
          />
        ))}
      </div>
    </div>
  );
};

SpaceAmenityFilter.displayName = 'SpaceAmenityFilter';
